var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-combobox',_vm._g(_vm._b({ref:"field",staticClass:"no-arrow",attrs:{"data-cy":_vm.dataCy,"outlined":"","single-line":""}},'v-combobox',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }